"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomer = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.getCustomer = (0, sonar_http_1.createGetEndpoint)((request) => { var _a; return `/api/v3/core/customers/${(_a = request === null || request === void 0 ? void 0 : request.customerId) !== null && _a !== void 0 ? _a : 'current'}`; }, {
    headers: (request) => {
        if (request === null || request === void 0 ? void 0 : request.shardName) {
            return { [sonar_http_1.HttpHeader.Shard]: request.shardName };
        }
        return {};
    }
});
//# sourceMappingURL=getCustomer.js.map